import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { ClientSchemaDetailsView } from '../components/views'

function ClientSchemaDetails() {
    return (
        <div className="clientSchemaDetails">
            <Sidebar />
            <MainView>
                <ViewTitle text={'Schema Client Details'} />
                <ClientSchemaDetailsView />
            </MainView>
        </div>
    )
}

export default ClientSchemaDetails
